let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iUv8g")).then(() => parcelRequire('6m8b0'));